import { render, staticRenderFns } from "./FormMetaDataset.vue?vue&type=template&id=1a85d09b&lang=pug"
import script from "./FormMetaDataset.vue?vue&type=script&lang=js"
export * from "./FormMetaDataset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a85d09b')) {
      api.createRecord('1a85d09b', component.options)
    } else {
      api.reload('1a85d09b', component.options)
    }
    module.hot.accept("./FormMetaDataset.vue?vue&type=template&id=1a85d09b&lang=pug", function () {
      api.rerender('1a85d09b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/FormMetaDataset.vue"
export default component.exports